import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import TrendingRoutes from './TrendingRoutes';
import WhyBooking from './WhyBooking';
import "../App.css";

// ===== BACKGROUND SLIDER IMAGES (src/Content/Flight_Images) =====
import slide1 from "../Content/Flight_Images/Slider1.png";
import slide2 from "../Content/Flight_Images/Slider2.jpg";
import slide3 from "../Content/Flight_Images/Slider3.jpg";

function Index() {
    const navigate = useNavigate();

    const [tripType, setTripType] = useState("O"); // O = One Way, R = Round Trip
    const [isSearching, setIsSearching] = useState(false);

    const [from, setFrom] = useState({
        city: "Dubai",
        code: "DXB",
        name: "Dubai International Airport"
    });

    const [to, setTo] = useState({
        city: "London",
        code: "LHR",
        name: "Heathrow Airport"
    });

    const [departDate, setDepartDate] = useState("");
    const [returnDate, setReturnDate] = useState("");
    const [departDisplay, setDepartDisplay] = useState({});
    const [returnDisplay, setReturnDisplay] = useState({});

    const [adults, setAdults] = useState(1);
    const [children, setChildren] = useState(0);
    const [infants, setInfants] = useState(0);
    const [travelClass, setTravelClass] = useState("Economy");
    const [showTravelerDropdown, setShowTravelerDropdown] = useState(false);
    const [airports, setAirports] = useState([]);
    const [airportsStatus, setAirportsStatus] = useState("loading"); // loading | ready | error
    const [fromQuery, setFromQuery] = useState("Dubai");
    const [toQuery, setToQuery] = useState("London");
    const [fromSuggestions, setFromSuggestions] = useState([]);
    const [toSuggestions, setToSuggestions] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const bgSlides = [slide1, slide2, slide3];
    const fromRef = useRef(null);
    const toRef = useRef(null);
    const travelerRef = useRef(null);
    const departInputRef = useRef(null);
    const returnInputRef = useRef(null);

    const fromSuggestionsRef = useRef([]);
    const toSuggestionsRef = useRef([]);
    useEffect(() => { fromSuggestionsRef.current = fromSuggestions; }, [fromSuggestions]);
    useEffect(() => { toSuggestionsRef.current = toSuggestions; }, [toSuggestions]);

    useEffect(() => {
        const loadAirports = async () => {
            const storedAirports = localStorage.getItem("airports");
            if (storedAirports) {
                try {
                    const parsed = JSON.parse(storedAirports);
                    if (Array.isArray(parsed) && parsed.length > 0) {
                        setAirports(parsed);
                        setAirportsStatus("ready");
                        return;
                    }
                } catch (e) {
                    localStorage.removeItem("airports");
                }
            }

            try {
               
                const AIRPORTS_ENDPOINT = "https://promo.namantechnolab.com/api/Air/Airports";
                const res = await fetch(AIRPORTS_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "APIToken": null,
                        "AgencyKey": "4AC0F2DD-66C2-4AC1-8AFD-DE615E223A4A",
                        "AccountNo": 17,
                        "IsDomestic": true,
                        "IsB2B": false
                    })
                });

                if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);

                const data = await res.json();
                const actualArray = Array.isArray(data)
                    ? data
                    : (data?.data && Array.isArray(data.data) ? data.data : []);

                if (actualArray.length > 0) {
                    setAirports(actualArray);
                    setAirportsStatus("ready");
                    localStorage.setItem("airports", JSON.stringify(actualArray));
                } else {
                    setAirportsStatus("error");
                }
            } catch (err) {
                console.error("Airport fetch failed:", err.message);
                setAirportsStatus("error");
            }
        };

        loadAirports();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (fromRef.current && !fromRef.current.contains(event.target)) {
                setFromSuggestions([]);
            }
            if (toRef.current && !toRef.current.contains(event.target)) {
                setToSuggestions([]);
            }
            if (travelerRef.current && !travelerRef.current.contains(event.target)) {
                setShowTravelerDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        const todayStr = new Date().toISOString().split('T')[0];
        const tomorrowStr = tomorrow.toISOString().split('T')[0];

        setDepartDate(todayStr);
        setReturnDate(tomorrowStr);

        updateDateDisplay(today, setDepartDisplay);
        updateDateDisplay(tomorrow, setReturnDisplay);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % bgSlides.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    const updateDateDisplay = (date, setter) => {
        if (!date || isNaN(date.getTime())) return;
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        setter({
            day: date.getDate(),
            month: months[date.getMonth()],
            year: date.getFullYear(),
            dayName: dayNames[date.getDay()]
        });
    };

    const handleSwap = () => {
        const tempFrom = from;
        const tempTo = to;
        setFrom(tempTo);
        setTo(tempFrom);
        setFromQuery(tempTo.city);
        setToQuery(tempFrom.city);
    };

    const handleDepartDateChange = (e) => {
        if (!e.target.value) return;
        const newDate = new Date(e.target.value);
        const today = new Date(); today.setHours(0,0,0,0);
        if (newDate < today) return; // past date reject
        setDepartDate(e.target.value);
        updateDateDisplay(newDate, setDepartDisplay);
        if (returnDate && new Date(returnDate) < newDate) {
            setReturnDate(e.target.value);
            updateDateDisplay(newDate, setReturnDisplay);
        }
    };

    const handleReturnDateChange = (e) => {
        if (!e.target.value) return;
        const newDate = new Date(e.target.value);
        setReturnDate(e.target.value);
        updateDateDisplay(newDate, setReturnDisplay);
    };

    const getFilteredAirports = (query) => {
        if (!Array.isArray(airports)) return [];
        const cleanQuery = (query || "").trim().toLowerCase();
        return airports.filter(a =>
            (a.CityName && a.CityName.toLowerCase().includes(cleanQuery)) ||
            (a.AirportCode && a.AirportCode.toLowerCase().includes(cleanQuery)) ||
            (a.AirportName && a.AirportName.toLowerCase().includes(cleanQuery))
        );
    };

    const handleInputFocus = (type, e) => {
        const query = type === "from" ? fromQuery : toQuery;
        const selectedCity = type === "from" ? from.city : to.city;

        if (query === selectedCity && e?.target) {
            e.target.select();
        }

        if (query.trim().length >= 3 && airports.length > 0) {
            const filtered = getFilteredAirports(query);
            if (type === "from") setFromSuggestions(filtered.slice(0, 10));
            else setToSuggestions(filtered.slice(0, 10));
        }
    };

    const handleFromChange = (e) => {
        const value = e.target.value;
        setFromQuery(value);
        if (value.trim().length >= 3) {
            setFromSuggestions(getFilteredAirports(value).slice(0, 10));
        } else {
            setFromSuggestions([]);
        }
    };

    const handleToChange = (e) => {
        const value = e.target.value;
        setToQuery(value);
        if (value.trim().length >= 3) {
            setToSuggestions(getFilteredAirports(value).slice(0, 10));
        } else {
            setToSuggestions([]);
        }
    };

    const selectFromAirport = (airport) => {
        setFrom({ city: airport.CityName, code: airport.AirportCode, name: airport.AirportName });
        setFromQuery(airport.CityName);
        setFromSuggestions([]);
    };

    const selectToAirport = (airport) => {
        setTo({ city: airport.CityName, code: airport.AirportCode, name: airport.AirportName });
        setToQuery(airport.CityName);
        setToSuggestions([]);
    };

    const handleFromBlur = () => {
        setTimeout(() => {
            if (fromSuggestionsRef.current.length === 0) {
                setFromQuery((prevQuery) => (prevQuery.trim() === "" ? from.city : prevQuery));
            }
            setFromSuggestions([]);
        }, 150);
    };

    const handleToBlur = () => {
        setTimeout(() => {
            if (toSuggestionsRef.current.length === 0) {
                setToQuery((prevQuery) => (prevQuery.trim() === "" ? to.city : prevQuery));
            }
            setToSuggestions([]);
        }, 150);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        setIsSearching(true);

        const routs = [
            {
                Source: from.code,
                InputSource: `${from.code} - ${from.name}`,
                Destination: to.code,
                OutputSource: `${to.code} - ${to.name}`,
                TravelDate: departDate
            }
        ];

        if (tripType === "R") {
            routs.push({
                Source: to.code,
                InputSource: `${to.code} - ${to.name}`,
                Destination: from.code,
                OutputSource: `${from.code} - ${from.name}`,
                TravelDate: returnDate
            });
        }

        const CLASS_MAP = {
            "Economy": 0,
            "Premium Economy": 1,
            "Business": 2,
            "First Class": 3
        };

        const payload = {
            "APIToken": null,
            "AgencyKey": "4AC0F2DD-66C2-4AC1-8AFD-DE615E223A4A",
            "AdultCount": Number(adults) || 1,
            "ChildCount": Number(children) || 0,
            "InfantCount": Number(infants) || 0,
            "PreferredAirlines": null,
            "Routs": routs,
            "TripType": tripType === "O" ? 0 : 1,
            "TypeOfClass": CLASS_MAP[travelClass] ?? 0,
            "IsDomestic": true,
            "SetAirport": null,
            "IsB2B": false,
            "IsSpecailFlight": false,
            "FromCity": null,
            "Tocity": null,
            "TransactionId": 0,
            "EngineType": 0,
            "AccountNo": 17
        };

        const queryParams = new URLSearchParams({
            origin: from.code,
            destination: to.code,
            date: departDate,
            trip: tripType
        }).toString();

        navigate(`/AirResponse/Index?${queryParams}`, { state: { searchData: payload } });
    };

    const totalTravelers = adults + children + infants;

    return (
        <div className="fs-page">
            <section className="fs-hero">
                {/* Background slider */}
                <div className="fs-hero-bg">
                    {bgSlides.map((img, idx) => (
                        <div
                            key={idx}
                            className="fs-hero-slide"
                            style={{
                                backgroundImage: `url(${img})`,
                                opacity: currentSlide === idx ? 1 : 0
                            }}
                        />
                    ))}
                    <div className="fs-hero-overlay" />
                </div>

                <div className="fs-hero-dots">
                    {bgSlides.map((_, idx) => (
                        <button
                            key={idx}
                            type="button"
                            aria-label={`Slide ${idx + 1}`}
                            className={`fs-dot ${currentSlide === idx ? "active" : ""}`}
                            onClick={() => setCurrentSlide(idx)}
                        />
                    ))}
                </div>

                <div className="fs-container">
                    <p className="fs-eyebrow">Fly further, spend less</p>
                    <h1 className="fs-heading">Domestic &amp; international flights</h1>
                    <p className="fs-subheading">Compare fares across airlines in seconds and lock in your seat.</p>

                    <div className="fs-card">
                        {/* Trip type toggle */}
                        <div className="fs-triptype">
                            <button
                                type="button"
                                className={`fs-trip-btn ${tripType === "O" ? "active" : ""}`}
                                onClick={() => setTripType("O")}
                            >
                                One way
                            </button>
                            <button
                                type="button"
                                className={`fs-trip-btn ${tripType === "R" ? "active" : ""}`}
                                onClick={() => setTripType("R")}
                            >
                                Round trip
                            </button>
                        </div>

                        <form onSubmit={handleSearch}>
                            <div className="fs-fields">

                                {/* FROM */}
                                <div className="fs-field fs-field-route" ref={fromRef}>
                                    <label className="fs-label">From</label>
                                    <input
                                        type="text"
                                        className="fs-input"
                                        value={fromQuery}
                                        onBlur={handleFromBlur}
                                        onChange={handleFromChange}
                                        onFocus={(e) => handleInputFocus("from", e)}
                                        placeholder="City or airport"
                                        autoComplete="off"
                                    />
                                    <span className="fs-sublabel">{from.code} &middot; {from.name}</span>

                                    {fromSuggestions.length > 0 && (
                                        <ul className="fs-suggestions">
                                            {fromSuggestions.map((airport, index) => (
                                                <li
                                                    key={airport.ID || index}
                                                    onMouseDown={(e) => { e.preventDefault(); selectFromAirport(airport); }}
                                                >
                                                    <span className="fs-sugg-main">{airport.CityName} <span className="fs-sugg-code">{airport.AirportCode}</span></span>
                                                    <span className="fs-sugg-sub">{airport.AirportName}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                    {fromSuggestions.length === 0 && fromQuery.trim().length >= 3 && airportsStatus !== "ready" && (
                                        <div className="fs-suggestions fs-suggestions-status">
                                            {airportsStatus === "loading" ? "Loading airports…" : "Couldn't load airport list. Please refresh."}
                                        </div>
                                    )}

                                    <button type="button" className="fs-swap" onClick={handleSwap} aria-label="Swap origin and destination">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M7 16V4M7 4L3 8M7 4l4 4"/>
                                            <path d="M17 8v12m0 0l4-4m-4 4l-4-4"/>
                                        </svg>
                                    </button>
                                </div>

                                {/* TO */}
                                <div className="fs-field fs-field-route" ref={toRef}>
                                    <label className="fs-label">To</label>
                                    <input
                                        type="text"
                                        className="fs-input"
                                        value={toQuery}
                                        onChange={handleToChange}
                                        onFocus={(e) => handleInputFocus("to", e)}
                                        onBlur={handleToBlur}
                                        placeholder="City or airport"
                                        autoComplete="off"
                                    />
                                    <span className="fs-sublabel">{to.code} &middot; {to.name}</span>

                                    {toSuggestions.length > 0 && (
                                        <ul className="fs-suggestions">
                                            {toSuggestions.map((airport, index) => (
                                                <li
                                                    key={airport.ID || index}
                                                    onMouseDown={(e) => { e.preventDefault(); selectToAirport(airport); }}
                                                >
                                                    <span className="fs-sugg-main">{airport.CityName} <span className="fs-sugg-code">{airport.AirportCode}</span></span>
                                                    <span className="fs-sugg-sub">{airport.AirportName}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                    {toSuggestions.length === 0 && toQuery.trim().length >= 3 && airportsStatus !== "ready" && (
                                        <div className="fs-suggestions fs-suggestions-status">
                                            {airportsStatus === "loading" ? "Loading airports…" : "Couldn't load airport list. Please refresh."}
                                        </div>
                                    )}
                                </div>

                                {/* DEPART */}
                                <div
                                    className="fs-field fs-field-date"
                                    onClick={() => departInputRef.current?.showPicker?.()}
                                >
                                    <label className="fs-label">Departure</label>
                                    <input
                                        ref={departInputRef}
                                        type="date"
                                        className="fs-date-input"
                                        value={departDate}
                                        onChange={handleDepartDateChange}
                                        min={new Date().toISOString().split('T')[0]}
                                    />
                                    <div className="fs-date-display">
                                        <span className="fs-date-day">{departDisplay.day}</span>
                                        <span className="fs-date-month">{departDisplay.month} {departDisplay.year}</span>
                                    </div>
                                    <span className="fs-sublabel">{departDisplay.dayName}</span>
                                </div>

                                {/* RETURN */}
                                {tripType === "R" && (
                                    <div
                                        className="fs-field fs-field-date"
                                        onClick={() => returnInputRef.current?.showPicker?.()}
                                    >
                                        <label className="fs-label">Return</label>
                                        <input
                                            ref={returnInputRef}
                                            type="date"
                                            className="fs-date-input"
                                            value={returnDate}
                                            onChange={handleReturnDateChange}
                                            min={departDate}
                                        />
                                        <div className="fs-date-display">
                                            <span className="fs-date-day">{returnDisplay.day}</span>
                                            <span className="fs-date-month">{returnDisplay.month} {returnDisplay.year}</span>
                                        </div>
                                        <span className="fs-sublabel">{returnDisplay.dayName}</span>
                                    </div>
                                )}

                                {/* TRAVELERS */}
                                <div className="fs-field fs-field-travelers" ref={travelerRef}>
                                    <div onClick={() => setShowTravelerDropdown(!showTravelerDropdown)} style={{ cursor: "pointer" }}>
                                        <label className="fs-label">Travelers &amp; class</label>
                                        <div className="fs-date-display">
                                            <span className="fs-date-day">{totalTravelers}</span>
                                            <span className="fs-date-month">Traveler{totalTravelers > 1 ? "s" : ""}</span>
                                        </div>
                                        <span className="fs-sublabel">{travelClass}</span>
                                    </div>

                                    {showTravelerDropdown && (
                                        <div className="fs-traveler-dropdown" onClick={(e) => e.stopPropagation()}>
                                            {[
                                                { label: "Adults", sub: "12+ yrs", val: adults, set: setAdults },
                                                { label: "Children", sub: "2–12 yrs", val: children, set: setChildren },
                                                { label: "Infants", sub: "Under 2 yrs", val: infants, set: setInfants }
                                            ].map((item, idx) => {
                                                const isAdultOrChild = item.label === "Adults" || item.label === "Children";
                                                const canIncrease = isAdultOrChild ? (adults + children < 9) : (infants < 9);
                                                const canDecrease = item.label === "Adults" ? item.val > 1 : item.val > 0;

                                                return (
                                                    <div key={idx} className="fs-traveler-row">
                                                        <div>
                                                            <div className="fs-traveler-label">{item.label}</div>
                                                            <div className="fs-traveler-sub">{item.sub}</div>
                                                        </div>
                                                        <div className="fs-stepper">
                                                            <button type="button" disabled={!canDecrease} onClick={() => item.set(item.val - 1)}>&minus;</button>
                                                            <span>{item.val}</span>
                                                            <button type="button" disabled={!canIncrease} onClick={() => item.set(item.val + 1)}>+</button>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                            <div className="fs-class-section">
                                                <div className="fs-class-title">Travel class</div>
                                                <div className="fs-class-grid">
                                                    {["Economy", "Premium Economy", "Business", "First Class"].map((cls) => (
                                                        <button
                                                            key={cls}
                                                            type="button"
                                                            className={`fs-class-btn ${travelClass === cls ? "active" : ""}`}
                                                            onClick={() => setTravelClass(cls)}
                                                        >
                                                            {cls}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>

                                            <button
                                                type="button"
                                                className="fs-done-btn"
                                                onClick={() => setShowTravelerDropdown(false)}
                                            >
                                                Done
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* SEARCH */}
                                <div className="fs-field fs-field-submit">
                                    <button type="submit" className="fs-search-btn" disabled={isSearching}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="11" cy="11" r="8"/>
                                            <path d="M21 21l-4.3-4.3"/>
                                        </svg>
                                        Search flights
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </section>

            <TrendingRoutes />
            <WhyBooking />

            <style>{`
                .fs-page {
                       --fs-navy: #1a2b6d;      
    --fs-navy-deep: #0f1a4a;
    --fs-sky: #2451c4;
    --fs-sunset-1: #e63950;  
    --fs-sunset-2: #ff6b7a;
    --fs-ink: #14213d;
    --fs-muted: #6b7688;
    --fs-border: #e4e8f0;
    --fs-bg: #f6f8fc;

                }

                .fs-hero {
                    position: relative;
    padding: 64px 20px 120px;
    min-height: 560px;
                }

                .fs-hero-bg
                 { 
                 position: absolute; inset: 0; z-index: 0;
    overflow: hidden; 
    border-radius: inherit;
                 }
                .fs-hero-slide {
                    position: absolute; inset: 0;
                    background-size: cover;
                    background-position: center;
                    transition: opacity 1.8s ease-in-out;
                }
                .fs-hero-overlay {
                    position: absolute; inset: 0;
                    background: linear-gradient(180deg, rgba(6,26,51,0.75) 0%, rgba(11,37,69,0.55) 45%, rgba(11,37,69,0.85) 100%);
                }

                .fs-hero-dots {
                    position: absolute;
                    bottom: 28px; left: 50%;
                    transform: translateX(-50%);
                    display: flex; gap: 8px;
                    z-index: 2;
                }
                .fs-dot {
                    width: 8px; height: 8px; border-radius: 50%;
                    border: none; padding: 0; cursor: pointer;
                    background: rgba(255,255,255,0.4);
                    transition: all 0.3s ease;
                }
                .fs-dot.active { background: #fff; width: 22px; border-radius: 4px; }

                .fs-container {
                    position: relative; z-index: 1;
                    max-width: 1180px; margin: 0 auto;
                    text-align: center;
                }

                .fs-eyebrow {
                    color: var(--fs-sunset-2);
                    font-size: 13px; font-weight: 600;
                    letter-spacing: 0.12em; text-transform: uppercase;
                    margin: 0 0 12px;
                }
                .fs-heading {
                    color: #fff;
                    font-size: clamp(28px, 4vw, 44px);
                    font-weight: 700;
                    line-height: 1.15;
                    margin: 0 0 12px;
                    letter-spacing: -0.02em;
                }
                .fs-subheading {
                    color: rgba(255,255,255,0.8);
                    font-size: 16px;
                    margin: 0 0 36px;
                }

                .fs-card {
                    background: rgba(255,255,255,0.97);
                    backdrop-filter: blur(12px);
                    border-radius: 20px;
                    box-shadow: 0 24px 60px rgba(6,26,51,0.35), 0 2px 8px rgba(6,26,51,0.08);
                    padding: 22px 22px 26px;
                    text-align: left;
                }

                .fs-triptype {
                    display: inline-flex;
                    background: var(--fs-bg);
                    border-radius: 10px;
                    padding: 4px;
                    margin-bottom: 20px;
                    gap: 4px;
                }
                .fs-trip-btn {
                    border: none; background: transparent;
                    padding: 9px 20px; border-radius: 7px;
                    font-size: 14px; font-weight: 600;
                    color: var(--fs-muted);
                    cursor: pointer; transition: all 0.2s ease;
                }
                .fs-trip-btn.active {
                    background: var(--fs-navy);
                    color: #fff;
                }

                .fs-fields {
                    display: grid;
                    grid-template-columns: 1.4fr 1.4fr 1fr 1fr 1.1fr auto;
                    gap: 0;
                    border: 1px solid var(--fs-border);
                    border-radius: 14px;
                    overflow: visible;
                }

                .fs-field {
                    position: relative;
                    padding: 14px 18px;
                    border-right: 1px solid var(--fs-border);
                }
                .fs-field:last-child { border-right: none; }

                .fs-label {
                    display: block;
                    font-size: 11px; font-weight: 600;
                    text-transform: uppercase; letter-spacing: 0.06em;
                    color: var(--fs-muted);
                    margin-bottom: 6px;
                }

                .fs-input {
                    border: none; outline: none;
                    width: 100%; font-size: 18px; font-weight: 700;
                    color: var(--fs-ink); background: transparent;
                    padding: 0; font-family: inherit;
                }
                .fs-input::placeholder { color: #b7bfcc; font-weight: 500; }

                .fs-sublabel {
                    display: block;
                    font-size: 12px; color: var(--fs-muted);
                    margin-top: 4px;
                    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                }

                .fs-swap {
                    position: absolute;
                    right: -14px; top: 50%;
                    transform: translateY(-50%);
                    width: 30px; height: 30px;
                    border-radius: 50%;
                    background: var(--fs-navy);
                    color: #fff;
                    border: 3px solid #fff;
                    display: flex; align-items: center; justify-content: center;
                    cursor: pointer; z-index: 5;
                    box-shadow: 0 2px 8px rgba(11,37,69,0.3);
                    transition: transform 0.2s ease;
                }
                .fs-swap:hover { transform: translateY(-50%) rotate(180deg); }
                @media (max-width: 1024px) {
    .fs-swap:hover { transform: translateX(50%) rotate(180deg); }
}

                .fs-suggestions {
                    position: absolute; top: calc(100% + 6px); left: 8px; right: 8px;
                    z-index: 50; background: #fff;
                    border: 1px solid var(--fs-border);
                    border-radius: 12px;
                    list-style: none; margin: 0; padding: 6px;
                    max-height: 260px; overflow-y: auto;
                    box-shadow: 0 12px 28px rgba(6,26,51,0.18);
                }
                .fs-suggestions li {
                    cursor: pointer; padding: 10px 10px;
                    border-radius: 8px;
                    display: flex; flex-direction: column; gap: 2px;
                }
                .fs-suggestions li:hover { background: var(--fs-bg); }
                .fs-sugg-main { font-size: 14px; font-weight: 600; color: var(--fs-ink); }
                .fs-sugg-code { color: var(--fs-sky); font-weight: 700; }
                .fs-sugg-sub { font-size: 12px; color: var(--fs-muted); }

                .fs-suggestions-status {
                    padding: 10px 12px;
                    font-size: 13px;
                    color: var(--fs-muted);
                }

                .fs-date-input {
                    position: absolute; inset: 0; opacity: 0;
                    width: 100%; height: 100%; cursor: pointer;
                }
                .fs-date-display { display: flex; align-items: baseline; gap: 6px; }
                .fs-date-day { font-size: 22px; font-weight: 700; color: var(--fs-ink); }
                .fs-date-month { font-size: 13px; font-weight: 600; color: var(--fs-muted); }

                .fs-field-travelers { cursor: pointer; }

                .fs-traveler-dropdown {
                    position: absolute; top: calc(100% + 8px); right: 0;
                    z-index: 60; background: #fff;
                    border: 1px solid var(--fs-border);
                    border-radius: 14px;
                    box-shadow: 0 16px 36px rgba(6,26,51,0.2);
                    width: 300px; padding: 18px;
                }
                .fs-traveler-row {
                    display: flex; justify-content: space-between; align-items: center;
                    padding: 8px 0;
                }
                .fs-traveler-label { font-size: 14px; font-weight: 600; color: var(--fs-ink); }
                .fs-traveler-sub { font-size: 12px; color: var(--fs-muted); }

                .fs-stepper { display: flex; align-items: center; gap: 12px; }
                .fs-stepper button {
                    width: 28px; height: 28px; border-radius: 50%;
                    border: 1px solid var(--fs-border); background: #fff;
                    color: var(--fs-navy); font-size: 16px; line-height: 1;
                    cursor: pointer; display: flex; align-items: center; justify-content: center;
                    transition: all 0.15s ease;
                }
                .fs-stepper button:hover:not(:disabled) { background: var(--fs-navy); color: #fff; border-color: var(--fs-navy); }
                .fs-stepper button:disabled { opacity: 0.35; cursor: not-allowed; }
                .fs-stepper span { min-width: 18px; text-align: center; font-weight: 700; color: var(--fs-ink); }

                .fs-class-section { margin-top: 14px; padding-top: 14px; border-top: 1px solid var(--fs-border); }
                .fs-class-title { font-size: 13px; font-weight: 700; color: var(--fs-ink); margin-bottom: 10px; }
                .fs-class-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
                .fs-class-btn {
                    padding: 9px; border-radius: 8px;
                    border: 1px solid var(--fs-border); background: #fff;
                    font-size: 13px; font-weight: 600; color: var(--fs-ink);
                    cursor: pointer; transition: all 0.15s ease;
                }
                .fs-class-btn.active { background: var(--fs-navy); border-color: var(--fs-navy); color: #fff; }

                .fs-done-btn {
                    margin-top: 16px; width: 100%; padding: 10px;
                    border: none; border-radius: 8px;
                    background: var(--fs-navy); color: #fff;
                    font-size: 14px; font-weight: 700; cursor: pointer;
                }

                .fs-field-submit { padding: 10px; display: flex; align-items: center; }
                .fs-search-btn {
                    display: flex; align-items: center; justify-content: center; gap: 8px;
                    height: 56px; padding: 0 26px;
                    border: none; border-radius: 12px;
                    background: linear-gradient(135deg, var(--fs-sunset-1), var(--fs-sunset-2));
                    color: #fff; font-size: 15px; font-weight: 700;
                    cursor: pointer; white-space: nowrap;
                    box-shadow: 0 10px 24px rgba(255,122,69,0.35);
                    transition: transform 0.15s ease, box-shadow 0.15s ease;
                }
                .fs-search-btn:hover { transform: translateY(-2px); box-shadow: 0 14px 28px rgba(255,122,69,0.45); }
                .fs-search-btn:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }

                @media (max-width: 1024px) {
                    .fs-fields { grid-template-columns: 1fr 1fr; }
                    .fs-field { border-right: none; border-bottom: 1px solid var(--fs-border); }
                    .fs-field:last-child { border-bottom: none; }
                    .fs-field-submit { grid-column: 1 / -1; }
                    .fs-search-btn { width: 100%; }
                    .fs-swap { right: 50% ;top: auto;bottom: -14px; transform: translateX(50%);}
                }

                @media (max-width: 560px) {
                    .fs-fields { grid-template-columns: 1fr; }
                    .fs-traveler-dropdown { right: auto; left: 0; width: 100%; }
                    .fs-hero { padding: 44px 14px 90px; }
                }
            `}</style>
        </div>
    );
}

export default Index;